import axios, { AxiosPromise } from 'axios';

import { IVariety } from '../../../@types/model/masterData/variety/variety';
import { IVarietyUpsert } from '../../../@types/model/masterData/variety/varietyUpsert';

export default class VarietyHttpService {
    public static getVarietyData(onlyActive ?: boolean, ignoreIncludes ?: boolean) : AxiosPromise<Array<IVariety>> {
        return axios.get(`${API_URL}/v1/Variety/GetAllWeb`, {
            params : {
                ignoreIncludes,
                onlyActive,
            },
        });
    }

    public static addOrUpdateVariety(upsert : IVarietyUpsert) : AxiosPromise<IVariety> {
        return axios.post(`${API_URL}/v1/Variety/PostVariety`, upsert);
    }

    public static deleteVariety(varietyId : number) : AxiosPromise<IVariety> {
        return axios.delete(`${API_URL}/v1/Variety/Delete`, {
            params : { varietyId },
        });
    }
}
